import { useEffect, useRef } from 'react'

/**
 * Custom react hook to do something on update and not mount
 *
 * @param effect Will be executed on update
 * @param deps If present, effect will only activate if the values in the list change.
 */
export const useDidUpdate = (effect, deps) => {
	const hasMounted = useRef(false)
	useEffect(() => {
		if (!hasMounted.current) {
			hasMounted.current = true
			return
		}
		effect()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps)
}
